import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronRight, LayoutDashboard, FileText, Users, Settings, Eye } from 'lucide-react';

interface AdminSidebarProps {
  onClose?: () => void;
}

export function AdminSidebar({ onClose }: AdminSidebarProps) {
  const [isFeatureMenuOpen, setIsFeatureMenuOpen] = useState(false);
  const [isHiddenPagesOpen, setIsHiddenPagesOpen] = useState(false);

  const handleClick = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm h-full py-6">
      <div className="px-4 mb-6">
        <div className="flex items-center space-x-2 px-3 py-2 bg-[#5e9bb8]/10 dark:bg-[#5e9bb8]/20 rounded-lg">
          <LayoutDashboard className="h-5 w-5 text-[#5e9bb8]" />
          <span className="font-semibold text-[#5e9bb8]">Admin Panel</span>
        </div>
      </div>

      <nav className="space-y-1 px-3">
        <div className="space-y-1">
          <button
            onClick={() => setIsFeatureMenuOpen(!isFeatureMenuOpen)}
            className="w-full flex items-center justify-between px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200"
          >
            <div className="flex items-center">
              <FileText className="h-5 w-5 mr-3" />
              <span>Feature Requests</span>
            </div>
            {isFeatureMenuOpen ? (
              <ChevronDown className="h-4 w-4" />
            ) : (
              <ChevronRight className="h-4 w-4" />
            )}
          </button>

          {isFeatureMenuOpen && (
            <div className="pl-11 space-y-1">
              <Link
                to="/admin/feature-requests"
                onClick={handleClick}
                className="block px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200"
              >
                View Requests
              </Link>
              <Link
                to="/admin/feature-requests/analytics"
                onClick={handleClick}
                className="block px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200"
              >
                Analytics
              </Link>
            </div>
          )}
        </div>

        <div className="space-y-1">
          <button
            onClick={() => setIsHiddenPagesOpen(!isHiddenPagesOpen)}
            className="w-full flex items-center justify-between px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200"
          >
            <div className="flex items-center">
              <Eye className="h-5 w-5 mr-3" />
              <span>Hidden Pages</span>
            </div>
            {isHiddenPagesOpen ? (
              <ChevronDown className="h-4 w-4" />
            ) : (
              <ChevronRight className="h-4 w-4" />
            )}
          </button>

          {isHiddenPagesOpen && (
            <div className="pl-11 space-y-1">
              <Link
                to="/products"
                onClick={handleClick}
                className="block px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200"
              >
                Products
              </Link>
              <Link
                to="/blog"
                onClick={handleClick}
                className="block px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200"
              >
                Blog
              </Link>
            </div>
          )}
        </div>

        <Link
          to="/admin/users"
          onClick={handleClick}
          className="flex items-center px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200"
        >
          <Users className="h-5 w-5 mr-3" />
          <span>User Management</span>
        </Link>

        <Link
          to="/admin/settings"
          onClick={handleClick}
          className="flex items-center px-3 py-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors duration-200"
        >
          <Settings className="h-5 w-5 mr-3" />
          <span>Settings</span>
        </Link>
      </nav>
    </div>
  );
}